import {
  createAction,
  createActionGroup,
  emptyProps,
  props,
} from "@ngrx/store";
import type {
  PipelineWorkspace,
  StatusFilter,
  TestPipelineRequest,
  StageOutputResponse,
} from "../pipeline.model";

export const PipelineActions = createActionGroup({
  source: "Pipeline",
  events: {
    "Load Workspace": emptyProps(),
    "Load Workspace Success": props<{ workspace: PipelineWorkspace }>(),
    "Load Workspace Failure": props<{ error: string }>(),

    Refresh: emptyProps(),
    "Select Client": props<{ index: number }>(),
    "Set Status Filter": props<{ filter: StatusFilter }>(),
    "Set Search": props<{ query: string }>(),
    "Set Polling Interval": props<{ intervalMs: number }>(),
    "Set Page": props<{ pageIndex: number; pageSize: number }>(),
    "View Pipeline Exceptions": props<{ uuid: string }>(),
    "Toggle Row": props<{ uuid: string }>(),

    "Retry Pipeline": props<{ uuid: string }>(),
    "Retry Pipeline Success": props<{ uuid: string }>(),
    "Retry Pipeline Failure": props<{ uuid: string; error: string }>(),

    "Cancel Pipeline": props<{ uuid: string }>(),
    "Cancel Pipeline Success": props<{ uuid: string }>(),
    "Cancel Pipeline Failure": props<{ uuid: string; error: string }>(),

    "Force Retry Pipeline": props<{ uuid: string }>(),
    "Force Retry Pipeline Success": props<{ uuid: string }>(),
    "Force Retry Pipeline Failure": props<{ uuid: string; error: string }>(),

    "Download Pipeline Output": props<{ uuid: string }>(),
    "Download Pipeline Output Failure": props<{
      uuid: string;
      error: string;
    }>(),

    "Download Stage Checkpoint": props<{ uuid: string; stageName: string }>(),
    "Download Stage Checkpoint Failure": props<{
      uuid: string;
      stageName: string;
      error: string;
    }>(),

    "Start Test Pipeline": props<{ request: TestPipelineRequest }>(),
    "Start Test Pipeline Success": props<{ pipelineId: string }>(),
    "Start Test Pipeline Failure": props<{ error: string }>(),

    "Load Stage Output": props<{ uuid: string; stageName: string }>(),
    "Load Stage Output Success": props<{
      uuid: string;
      stageName: string;
      output: StageOutputResponse;
    }>(),
    "Load Stage Output Failure": props<{
      uuid: string;
      stageName: string;
      error: string;
    }>(),
  },
});

// Legacy action for backward compatibility with homing-pigeon messages
export const updatePipelineProgress = createAction(
  "[Pipeline] Update Pipeline Progress",
  props<{ pipeline: any }>(),
);
